<template>
  <div>
    <slot></slot>
  </div>
</template>

<script lang="ts">
import { mapActions } from 'vuex';
import { FETCH_PLACES } from '../../../store/destinies/action-types';

export default {
  created() {
    this.fetchPlaces().catch(() => {
      this.$toastr.e(
        "Ha ocurrido un error durante la búsqueda. Inténtalo nuevamente."
      );
    });
  },
  methods: {
    ...mapActions({
      fetchPlaces: FETCH_PLACES
    })
  },
};
</script>

<style lang="scss">
@import "../../../../sass/variables";

.flights-search {
  max-width: 1240px;
  width: 100%;

  @media screen and (min-width: 1240px) {
    margin: 30px auto;
  }

  .search-card {
    padding: 1.25rem 0;
    border-radius: 1rem;

    @media (min-width: $breakpoint-landing-phone) {
      background-color: white;
      padding-left: 0.5rem;
      padding-right: 0.5rem;
      padding-bottom: 0.4rem;
    }
  }
  
  .floating-container {
    position: absolute;
    padding: 3rem 1rem 1.25rem;

    @media (min-width: $breakpoint-landing-phone) {
      padding: 2.5rem;
    }

    left: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }
}
</style>
